import React from 'react';
import { Rate } from '@components/rate/styled.ts';
import type { RateProps as BaseRateProps } from 'antd';

export type { BaseRateProps };

export const BaseRate: React.FC<BaseRateProps> = ({ ...props }) => <Rate {...props} />;
